import { Target, MessageSquare, TrendingUp, Users, Shield, Puzzle } from 'lucide-react';

export const problems = [
  // 3. Interpersonal and Cultural Dynamics
  {
    icon: Users,
    title: 'Interpersonal and Cultural Dynamics',
    points: [
      'Having difficulty interpreting cultural and interpersonal nuances',
      'Lacking awareness of how your work style fits within the team culture',
      'Struggling to uncover and address hidden biases in evaluations'
    ]
  },
  // 4. Career Growth Frustrations
  {
    icon: TrendingUp,
    title: 'Career Growth Frustrations',
    points: [
      'Feeling stuck in a cycle of being "good enough" but overlooked for promotions',
      'Struggling to understand and meet expectations for your next career step',
      'Facing a misalignment between your goals and perceived readiness'
    ]
  },
  // 5. Feedback Accessibility and Method Trust
  {
    icon: Shield,
    title: 'Feedback Accessibility and Method Trust',
    points: [
      'Noticing reluctance from colleagues to provide honest feedback',
      'Finding feedback often diluted by managerial or HR filtering',
      'Missing out on authentic and valuable insights'
    ]
  },
  // 1. Lack of Clarity and Focus
  {
    icon: Target,
    title: 'Lack of Clarity and Focus',
    points: [
      'Wrestling to identify which strengths to amplify for career advancement',
      'Lacking actionable insights on specific areas for growth',
      'Finding it challenging to bridge the gap between your self-perception and how others perceive you'
    ]
  },
  // 6. Missing Features in Current Tools
  {
    icon: Puzzle,
    title: 'Missing Features in Current Tools',
    points: [
      'Lacking frameworks for self-diagnosing your readiness',
      "Not having structured mechanisms to gather and act on feedback",
      'Missing guidance for impactful post-feedback conversations'
    ]
  },
  // 2. Challenges Navigating Feedback
  {
    icon: MessageSquare,
    title: 'Challenges Navigating Feedback',
    points: [
      'Fearing receiving critical feedback and navigating its implications',
      'Experiencing inconsistent or unstructured feedback processes',
      'Feeling uncertain about how to trust or prioritize feedback'
    ]
  }
];